import { render, staticRenderFns } from "./ManutenzioneGestioneLuoghi.vue?vue&type=template&id=6446acaf&scoped=true&"
import script from "./ManutenzioneGestioneLuoghi.vue?vue&type=script&lang=js&"
export * from "./ManutenzioneGestioneLuoghi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446acaf",
  null
  
)

export default component.exports